import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { UsersService } from '../../services/users-service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { EditUserRolesComponent } from '../edit-user-roles/edit-user-roles.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AddUserComponent } from '../add-user/add-user.component';
import { PagingService } from '../../../../shared/Services/PagingService';

@Component({
  selector: 'app-get-users-component',
  templateUrl: './get-users-component.component.html',
  styleUrls: ['./get-users-component.component.scss'],
})
export class GetUsersComponentComponent extends BaseComponent implements OnInit {
  form: FormGroup;

  constructor(
    public service: UsersService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
  initForm() {
    this.form = this.fb.group({
      email: [''],
    });
  }

  clearFilter() {
    this.form.controls['email'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  handleSearch() {
    if (!this.form.value.email) {
      this.toast.danger('برجاءاختيار الايميل لاتمام عملية البحث', 'رساله تحذيرية');
      return;
    }

    if (this.form.value.email.trim()) {
      const email = this.form.value.email.trim();
      this.form.controls['email'].setValue(email);
      this.loadEntitiesWithFilter(`email:${email}`);
    }
  }

  addNew() {
    this.diag
      .open(AddUserComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  toggleUserStatus(model: any, isActive: boolean) {
    if (!isActive) {
      
      this.service.delete(model.id).subscribe({
        next: (res) => {
          model.isDeleted = true;
          this.toast.show('تم تعطيل حساب المستخدم بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.toast.danger('حدث خطأ أثناء تعطيل  حساب المستخدم', 'خطأ', { status: 'danger', duration: 3000 });
        }
      });
    } else {
      
      const updateData = {
        email: model.email,
        userName: model.userName,
        isDeleted: false
      };
      
      this.service.put(model.id, updateData).subscribe({
        next: (res) => {
          model.isDeleted = false;
          this.toast.show('تم تفعيل المستخدم بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.toast.danger('حدث خطأ أثناء تفعيل المستخدم', 'خطأ', { status: 'danger', duration: 3000 });
        }
      });
    }
  }

  updateRole(model) {
    this.diag
      .open(EditUserRolesComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: model,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
